<template>
	<div class="contentbox">
		<div class="media-add-video-list">
			<div class="top-search">
				<el-form :inline="true" :model="formInline" ref="formInline" size="small" class="demo-form-inline">
					<!--<el-form-item label="小程序" prop="appId" v-if="!isAgent">-->
					<!--<app-list @getAppId="getAppId" :appId="formInline.appId" clear="noclear"></app-list>-->
					<!--</el-form-item>-->
					<el-form-item label="小说ID" prop="bookId">
						<el-input type="number" v-model="formInline.bookId" placeholder="请输入短剧ID" clearable
							@keyup.enter.native="search" @clear="search" style="width: 200px;"></el-input>
					</el-form-item>
					<el-form-item label="小说名称" prop="bookName">
						<el-input v-model="formInline.bookName" placeholder="请输入小说名" clearable @keyup.enter.native="search" @clear="search" style="width: 200px;"></el-input>
					</el-form-item>
					<el-form-item label="创建状态" prop="createStatus" style="margin-right: 30px;">
						<el-select v-model="formInline.createStatus" placeholder="请选择创建状态" clearable @change="search"
							style="width: 150px;">
							<el-option v-for="item in createStatusOptions" :key="item.value" :label="item.label"
								:value="item.value"></el-option>
						</el-select>
					</el-form-item>
					<el-form-item label="资源上下架状态" prop="novelOperateStatus" style="margin-right: 30px;">
						<el-select v-model="formInline.novelOperateStatus" placeholder="请选择资源上下架状态" clearable @change="search" style="width: 150px;">
							<el-option v-for="item in novelOperateStatusOptions" :key="item.value" :label="item.label" :value="item.value"></el-option>
						</el-select>
					</el-form-item>
					<el-form-item label="小说类型" prop="novelType" style="margin-right: 30px;">
						<el-select v-model="formInline.novelType" placeholder="请选择小说类型" clearable @change="search" style="width: 150px;">
							<el-option v-for="item in novelTypeOptions" :key="item.value" :label="item.label" :value="item.value"></el-option>
						</el-select>
					</el-form-item>
					<el-form-item>
						<el-button type="primary" icon="el-icon-search" @click="search">查询</el-button>
					</el-form-item>
					<el-form-item>
						<el-button icon="el-icon-refresh" @click="resetQuery">重置</el-button>
					</el-form-item>
					<br/>
					<el-form-item>
						<el-button type="success" icon="el-icon-refresh" v-has="'novvel:batchAuthorize'" @click="authorizeBtn">批量授权</el-button>
					</el-form-item>
				</el-form>
			</div>
			<div class="tableTh" v-height>
				<el-table :data="tableData.result" border stripe @selection-change="handleSelectionChange" style="width: 100%"
					height="100%" class="tableStyle" v-loading="loadingTabel">
					<!--<el-table-column type="selection" width="60" align="center">-->
					<!--</el-table-column>-->
					<el-table-column label="序号" width="80">
						<template slot-scope="scope">
							<span>{{ (tableData.pageNo - 1) * tableData.pageSize + scope.$index + 1 }}</span>
						</template>
					</el-table-column>
					<el-table-column prop="bookId" label="小说ID" width="180"></el-table-column>
					<el-table-column label="小说信息">
						<template slot-scope="scope">
							<div class="td-info">
								<p>小说名称：{{ scope.row.bookName }}</p>
								<p>作品状态：{{ scope.row.serialStatus === 2 ? '完结' : '连载' }}</p>
								<p>小说类型：{{ scope.row.novelType === 1 ? '短篇' : '长篇' }}</p>
								<p>总字数：{{ scope.row.sumWords }}</p>
								<p>总章数：{{ scope.row.chapterSize }}</p>
								<p>付费信息：付费</p>
							</div>
						</template>
					</el-table-column>
					<el-table-column label="封面" width="150">
						<template slot-scope="scope">
							<img class="cover" :src="scope.row.coverName" />
						</template>
					</el-table-column>
					<el-table-column label="创建状态" width="130" align="center">
						<template slot-scope="scope">
							<span v-if="scope.row.createStatus == 0" class="danger-text">未创建</span>
							<span v-if="scope.row.createStatus == 1" class="succes-text">已创建</span>
						</template>
					</el-table-column>
					<el-table-column label="资源上架状态" width="130" align="center">
						<template slot-scope="scope">
							<span v-if="scope.row.novelOperateStatus == 0" class="danger-text">未上架</span>
							<span v-if="scope.row.novelOperateStatus == 1" class="succes-text">已上架</span>
						</template>
					</el-table-column>
					<el-table-column prop="errorInfo" label="错误信息" width="180"></el-table-column>
					<el-table-column prop="message" label="错误原因" width="180"></el-table-column>
					<el-table-column label="操作" fixed="right">
						<template slot-scope="scope" class="ddd">
							<el-button type="defult" icon="el-icon-warning-outline" size="mini"
								@click="handleLook(scope.row.bookId)">详情</el-button>
							<el-button v-if="scope.row.novelOperateStatus == 0" v-has="'novvel:UdpOperateStatus'" type="success" size="mini" @click="handleStatus(scope.row.bookId, scope.row.novelOperateStatus)">上架</el-button>
							<el-button v-if="scope.row.novelOperateStatus == 1" v-has="'novvel:UdpOperateStatus'" type="danger" size="mini" @click="handleStatus(scope.row.bookId, scope.row.novelOperateStatus)">下架</el-button>
							<!--<el-button v-has="'info:update'" type="primary" icon="el-icon-edit" size="mini"-->
								<!--@click="handleEdit(scope.row.id)">编辑</el-button>-->
							<!--<el-popover v-has="'info:delete'" width="160" :ref="scope.row.id" style="margin-left: 10px;">-->
								<!--<p class="popover-con del">-->
									<!--<i class="el-icon-question warnning-text"></i>确定删除吗？-->
								<!--</p>-->
								<!--<div style="text-align: right;">-->
									<!--<el-button size="mini" @click="$refs[scope.row.id].doClose()">取消</el-button>-->
									<!--<el-button type="primary" size="mini" @click="handleDelete(scope.row.id)">确定</el-button>-->
								<!--</div>-->
								<!--<el-button slot="reference" type="danger" icon="el-icon-delete"-->
									<!--:disabled="scope.row.rackStatus == 1 ? true : false" size="mini">删除</el-button>-->
							<!--</el-popover>-->
						</template>
					</el-table-column>
				</el-table>
				<div class="foot-table" style="text-align:center;">
					<el-pagination @current-change="handleCurrentChange" @size-change="handleSizeChange"
						:page-sizes="[20, 50, 100, 200, 500]" :page-size="tableData.pageSize" background :current-page="currentPage"
						layout="sizes, prev, pager, next, jumper, ->, total" :total="tableData.totalNum">
					</el-pagination>
				</div>
			</div>
		</div>
		<!--详情-->
		<el-dialog title="详情" :visible.sync="dialogInfoVisible" center width="800px">
			<table class="el-table el-table--border el-table--enable-row-hover mytable" cellspacing="0" cellpadding="0">
				<tbody>
					<tr>
						<td>小说ID</td>
						<td>
							{{ruleForm.bookId}}
						</td>
					</tr>
					<tr>
						<td width="200">小说信息</td>
						<td>
							<p>小说名称：{{ ruleForm.bookName }}</p>
							<p>
								作品状态：
								<span v-if="ruleForm.serialStatus == 1" class="primary-text">连载</span>
								<span v-if="ruleForm.serialStatus == 2" class="succes-text">完结</span>
							</p>
							<p>小说类型：{{ ruleForm.novelType == 1 ? '短篇' : '长篇' }}</p>
							<p>总字数：{{ ruleForm.sumWords }}</p>
							<p>总章数：{{ ruleForm.chapterSize }}</p>
							<p>付费信息：付费</p>
						</td>
					</tr>
					<tr>
						<td>小说封面</td>
						<td>
							<img class="cover" :src="ruleForm.coverName" />
						</td>
					</tr>
				</tbody>
			</table>
			<div slot="footer" class="dialog-footer">
				<el-button type="primary" @click="dialogInfoVisible = false">确 定</el-button>
			</div>
		</el-dialog>
		<!--修改弹框-->
		<el-dialog title="同步配置内容" :visible.sync="configFormVisible" width="700px">
			<el-form :rules="configRules" ref="configRuleForm" :model="configRuleForm" label-width="150px" class="input350"
				size="small" style="max-height: 550px;overflow: auto; padding-right: 20px;">
				<el-form-item label="同步至：" prop="appIdson">
					<el-select v-model="appIdson" filterable clearable placeholder="请选择小程序" style="width: 280px;">
						<el-option v-for="item in appOptions" :key="item.appId" :label="item.name" :value="item.appId"
							:disabled="item.disabled || false"></el-option>
					</el-select>
				</el-form-item>
			</el-form>
			<div slot="footer" class="dialog-footer">
				<el-button @click="configFormVisible = false">取 消</el-button>
				<el-button type="primary" @click="configEditDialogSureBtn('configRuleForm')">确 定</el-button>
			</div>
		</el-dialog>
	</div>
</template>
<script>
// import VideoTableMedia from '@/components/VideoTableMedia'
// import AppTableMore from '@/components/AppTableMore'
import { listMedia, details, authorize, operateStauts} from "@/api/dydp/media/media";
// import videojs from "video.js";
// import "video.js/dist/video-js.css";
export default {
	data() {
		var validateNum = (rule, value, callback) => {
			if (!(/(^[1-9]\d*$)/.test(value))) {
				return callback(new Error('数字应为正整数'));
			} else {
				callback();
			}
		};
		var validateAppIdson = (rule, value, callback) => {
			if (!this.appIdson) {
				return callback(new Error('请选择同步小程序'));
			} else {
				callback();
			}
		};
		return {
			loadingTabel: false,
			formInline: {
				appId: localStorage.getItem('appId'),
				bookId: '',
				bookName: '',
                createStatus: '',
                novelOperateStatus: '',
                novelType: ''
			},
            createStatusOptions: [
                {
                    value: 0,
                    label: '未创建'
                },
                {
                    value: 1,
                    label: '已创建'
                }
            ],
            novelOperateStatusOptions: [
				{
					value: 0,
					label: '未上架'
				},
				{
					value: 1,
					label: '已上架'
				}
			],
            novelTypeOptions: [
                {
                    value: 1,
                    label: '短篇'
                },
                {
                    value: 2,
                    label: '长篇'
                }
            ],
			priceFlagOptions: [
				{
					value: 0,
					label: '纯付费解锁'
				},
				{
					value: 2,
					label: '纯广告解锁'
				},
				{
					value: 3,
					label: '单集付费+广告解锁'
				}
			],
			idList: [],
			tableData: {
				pageSize: 20,
				pageNo: 1,
				totalPage: 1,
				totalNum: 1,
				result: []
			},
			currentPage: 1,
			dialogInfoVisible: false, // 详情弹框
			dialogTitle: '添加',
			dialogFormVisible: false, // 编辑弹框
			updateType: 'add',
			labelListOptions: [],
			ruleForm: {
			},
			rules: {
				videoId: [
					{ required: true, message: '请选择短剧', trigger: 'change' }
				],
				finishPrice: [
					{ required: true, message: '请选择输入整剧价格', trigger: 'blur' },
					{ validator: validateNum, trigger: 'blur' }
				]
			},
			isShowDialogVideo: false,
			isShowDialogApp: false,
			isAgent: false,
			configFormVisible: false,
			configRuleForm: {
				// appIdson:''
			},
			appIdson: '',
			configRules: {
				appIdson: [
					{ validator: validateAppIdson, trigger: 'change' },
				],
			},
			appOptions: [
				{
					appId: '',
					name: '',
					disabled: false,
				}
			],
			dialogViewVisible:false,//预览剧集
			seriesList:{},
			previewSvId:'',
			pageVal:'',
			dp:null,
			isM3U8:false,
			options: {
				playbackRates: [0.7, 1.0, 1.5, 2.0], //播放速度
				// aspectRatio:'9:16',
				notSupportedMessage: '此视频暂无法播放，请稍后再试', //允许覆盖Video.js无法播放媒体源时显示的默认信息。
				autoplay: false, // 设置自动播放
				inactivityTimeout: 0,
				muted: true, // 设置了它为true，才可实现自动播放,同时视频也被静音（Chrome66及以上版本，禁止音视频的自动播放）
				preload: "auto", // 预加载
				controls: true, // 显示播放的控件
			},
		}
	},
	computed: {},
	watch: {
	},
	mounted: function () {
		if (JSON.parse(localStorage.getItem('accountInfo')).bangdingAppId) {
			this.isAgent = true
			this.formInline.appId = JSON.parse(localStorage.getItem('accountInfo')).bangdingAppId
		}
		this.getTableData()
		this.authorizeBtn()
	},
	beforeDestroy() {
	},
	methods: {
        search () {
            this.currentPage = 1
            this.getTableData()
        },
        resetQuery() {
            this.$refs['formInline'].resetFields()
            this.getTableData()
            // console.log(formName)
            // this.$refs[formName].resetFields()
            // this.getTableData()
        },
        handleSelectionChange(val) {
            var that = this
            that.idList = []
			val.forEach((item) => {
				that.idList.push(item.id)
			})
            console.log(that.idList)
        },
        handleCurrentChange(value) {
            this.currentPage = value
            this.getTableData()
        },
        handleSizeChange(val) {
            this.tableData.pageSize = val
            this.currentPage = 1
            this.getTableData()
        },
        getDetails(id) {
            details({
                bookId: id
            }).then(response => {
                if (response.data.head.flag === 0) {
					this.ruleForm = response.data.content
				} else {
					this.$message.error(response.data.head.desc)
				}
			});
        },
        handleStatus(id, status) {
            operateStauts({
                bookId: id,
                operate: status === 0 ? 1 : 0
            }).then(response => {
                if (response.data.head.flag === 0) {
                    this.$message({
                        message: '请求成功',
                        type: 'success'
                    });
                    this.getTableData()
                } else {
                    this.$message.error(response.data.head.desc)
                }
            });
		},
        handleLook(id) {
            console.log(id)
            this.dialogInfoVisible = true
            this.getDetails(id)
        },
        getTableData() {
            let json2 = {
                pageNo: this.currentPage,
                pageSize: this.tableData.pageSize
            };
            let json1 = this.formInline;
            let paramJson = { ...json1, ...json2 };
            listMedia(paramJson).then(response => {
                if (response.data.head.flag === 0) {
					this.tableData = response.data.content
				} else {
					this.$message.error(response.data.head.desc)
				}
			});
        },
        authorizeBtn() {
            authorize({
                authNovelOperate: 1,
                chargeType: 4
			}).then(response => {
                if (response.data.head.flag === 0) {
					this.$message({
						message: '请求成功',
						type: 'success'
					});
				} else {
					this.$message.error(response.data.head.desc)
				}
			});
		},
	}
}
</script>
<style lang="scss" scoped>
.preview-img {
  width: 100%;
  text-align: center;

	.preview-title{
		font-size: 16px;
		margin: -60px 0 30px 0;
	}

	.video-demo {
		width: 100%;
		height: 100%;
	}

	video {
		max-width: 100%;
		max-height: 100%;
		object-fit: contain; /* 保持视频比例 */
	}
 
}

</style>
